export default {
  workbench: "Workbench",
  taskCenter: "Task Center",
  messageNotification: "Message Notifications",
  supplierManagement: "Supplier Management",
  supplierProfileManagement: "Supplier Profile Management",
  emailInvite: "Email Invite",
  supplierProfileDetail: "Supplier Profile Detail",
  supplierPerformanceManagement: "Supplier Performance Management",
  assessmentTemplateManagement: "Assessment Template Management",
  admissionAssessmentTemplate: "Admission Assessment Template",
  performanceAssessmentTemplate: "Performance Assessment Template",
  addTemplate: "Add Template",
  supplierExceptionManagement: "Supplier Exception Management",
  supplierRiskLevel: "Supplier Risk Level",
  materialException: "Material Exception Registration",
  supplierVisitAuditManagement: "Supplier Visit & Audit Management",
  visitManagement: "Visit Management",
  auditManagement: "Audit Management",
  requirementManagement: "Requirements Management",
  sourcingApplicationManagement: "Sourcing Application Management",
  purchaseApplicationManagement: "Purchase Application Management",
  priceInquiryManagement: "Price Inquiry Management",
  priceCompareDetail: "Price Compare Detail",
  contractManagement: "Contract Management",
  purchaseOrderManagement: "Purchase Order Management",
  systemSettings: "System Settings",
  orderDetail: "Order Detail",
};
